export default __webpack_public_path__ + "static/ai_banner3-79b9f72b7e0f2735f131f5a82873b475.jpg";